import { api } from "@/lib/api";

/** Download a server-generated export (CSV/XLSX) with auth + tenant headers.
 *  Pass {method:"post", data} for endpoints that need a request body. */
export async function downloadExport(path, params, filename, opts = {}) {
  const res = opts.method === "post"
    ? await api.post(path, opts.data || {}, { params, responseType: "blob" })
    : await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
